import { Head, router } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import TimeEntryForm, { type TimeEntryData } from "./_form"

interface CaseRecord {
  id: number
  case_number: string
  display_name: string
}

interface Props {
  case_record: CaseRecord
  time_entry: TimeEntryData
  users: { id: number; name: string }[]
  service_item_types: {
    id: number
    name: string
    cost: number
    price: number
  }[]
  travel_hour_options: { value: number; label: string }[]
  can_view_financials: boolean
  can_select_employee: boolean
  can_use_block_time: boolean
  errors?: Record<string, string[]>
}

export default function New({
  case_record,
  time_entry,
  users,
  service_item_types,
  travel_hour_options,
  can_view_financials,
  can_select_employee,
  can_use_block_time,
  errors,
}: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Cases", href: "/cases" },
    {
      title: case_record.display_name || case_record.case_number,
      href: `/cases/${case_record.id}`,
    },
    { title: "Time Entries", href: `/cases/${case_record.id}/time_entries` },
    { title: "New", href: `/cases/${case_record.id}/time_entries/new` },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`New Time Entry - ${case_record.case_number}`} />

      <div className="p-6">
        <h1 className="mb-6 text-2xl font-semibold">Add Time Entry</h1>

        <div className="rounded-lg bg-white p-6 shadow">
          <TimeEntryForm
            caseId={case_record.id}
            timeEntry={time_entry}
            users={users}
            serviceItemTypes={service_item_types}
            travelHourOptions={travel_hour_options}
            canViewFinancials={can_view_financials}
            canSelectEmployee={can_select_employee}
            canUseBlockTime={can_use_block_time}
            errors={errors}
            onCancel={() => router.get(`/cases/${case_record.id}/time_entries`)}
          />
        </div>
      </div>
    </AppLayout>
  )
}
